var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 15H15.75",
    stroke: "#51CA64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.375 3.46599C12.6734 3.16762 13.078 3 13.5 3C13.7089 3 13.9158 3.04115 14.1088 3.12111C14.3019 3.20106 14.4773 3.31825 14.625 3.46599C14.7727 3.61373 14.8899 3.78912 14.9699 3.98214C15.0498 4.17517 15.091 4.38206 15.091 4.59099C15.091 4.79992 15.0498 5.00681 14.9699 5.19984C14.8899 5.39286 14.7727 5.56825 14.625 5.71599L5.25 15.091L2.25 15.841L3 12.841L12.375 3.46599Z",
    stroke: "#51CA64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.d5320503242dd9e398625ba7270a9736.svg";
export { ForwardRef as ReactComponent };